import { render, staticRenderFns } from "./StudentLeaveSubApproval.vue?vue&type=template&id=6aef7176&scoped=true&"
import script from "./StudentLeaveSubApproval.vue?vue&type=script&lang=js&"
export * from "./StudentLeaveSubApproval.vue?vue&type=script&lang=js&"
import style0 from "./StudentLeaveSubApproval.vue?vue&type=style&index=0&id=6aef7176&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aef7176",
  null
  
)

export default component.exports